<ng-container [formGroup]="formGroup">
  <div class="columns">
    <iss-form-field class="column">
      <iss-label>{{ 'iss-wo-common.recurrence-schedule.labels.frequency' | translate }}</iss-label>
      <iss-exclusive-buttons [items]="frequencies" formControlName="frequency" [readonly]="readonly">
        <ng-template let-item>
          <span [attr.data-e2e]="item + ' reccurence button'">{{ item | recurrenceScheduleFrequency }}</span>
        </ng-template>
      </iss-exclusive-buttons>
      <ng-template issFormFieldError let-errors>
        <ng-container *ngIf="errors.required">{{ 'iss-core.error.required' | translate }}</ng-container>
      </ng-template>
    </iss-form-field>
  </div>
  <div class="columns" *ngIf="formGroup.value.frequency">
    <iss-form-field class="column" [ngSwitch]="formGroup.value.frequency">
      <iss-label>{{ 'iss-wo-common.recurrence-schedule.labels.recurrence' | translate }}</iss-label>
      <ng-container *ngSwitchCase="Frequency.Daily">
        <div class="field">
          <div class="control wo-recurrence-schedule-configurator__radios">
            <label class="radio">
              <input
                type="radio"
                [value]="DailyScheduleType.EveryDay"
                formControlName="dailyType"
                (click)="onActivate()"
              />
              <wo-daily-recurrence>
                <input
                  issInput
                  type="number"
                  class="iss-daily-recurrence-input"
                  data-e2e="daily recurrence number field"
                  formControlName="dailyRecurrenceCounter"
                  [placeholder]="'iss-wo-common.recurrence-schedule.recurrence-type.day' | translate"
                  [readonly]="readonly"
                >
              </wo-daily-recurrence>
            </label>
            <label class="radio">
              <input
                type="radio"
                [value]="DailyScheduleType.EveryWeekday"
                formControlName="dailyType"
                (click)="onActivate()"
              />
              Recur every weekday
            </label>
          </div>
        </div>
      </ng-container>
      <wo-weekly-recurrence *ngSwitchCase="Frequency.Weekly">
        <input
          issInput
          type="number"
          class="iss-daily-recurrence-input"
          data-e2e="weekly recurrence number field"
          formControlName="weeklyRecurrenceCounter"
          [placeholder]="'iss-wo-common.recurrence-schedule.recurrence-type.week' | translate"
          [readonly]="readonly"
        >
        <iss-inclusive-buttons [items]="daysOfWeek" formControlName="weeklyRecurrenceDayNames" [readonly]="readonly">
          <ng-template let-item>
            <span [attr.data-e2e]="'service on ' + item + ' button'">{{ item | recurrenceDayOfWeek }}</span>
          </ng-template>
        </iss-inclusive-buttons>
      </wo-weekly-recurrence>
      <ng-container *ngSwitchCase="Frequency.Monthly">
        <div class="field">
          <div class="control wo-recurrence-schedule-configurator__radios">
            <label class="radio">
              <input
                type="radio"
                [value]="MonthlyScheduleType.EveryMonth"
                formControlName="monthlyType"
                (click)="onActivate()"
              />
              <wo-monthly-recurrence>
                <input
                  issInput
                  type="number"
                  class="iss-daily-recurrence-input"
                  data-e2e="month day number field"
                  formControlName="monthlyRecurrenceDayNumber"
                  [placeholder]="'iss-wo-common.recurrence-schedule.recurrence-type.day' | translate"
                  [readonly]="readonly"
                >
                <input
                  issInput
                  type="number"
                  class="iss-daily-recurrence-input"
                  data-e2e="monthly recurrence number field"
                  formControlName="monthlyRecurrenceCounter"
                  [placeholder]="'iss-wo-common.recurrence-schedule.recurrence-type.month' | translate"
                  [readonly]="readonly"
                >
              </wo-monthly-recurrence>
            </label>
            <label class="radio">
              <input
                type="radio"
                [value]="MonthlyScheduleType.NthMonth"
                formControlName="monthlyType"
                (click)="onActivate()"
              />
              <wo-monthly-nth-recurrence>
                <iss-select
                  class="iss-monthly-recurrence-input"
                  formControlName="monthlyRecurrenceConfigType"
                  [items]="monthlyTypes"
                  [readonly]="readonly"
                  [placeholder]="'button.select' | translate"
                >
                  <ng-template issSelectOption let-item>
                    {{ item | monthlyRecurrenceType }}
                  </ng-template>
                </iss-select>
                <iss-select
                  class="iss-monthly-recurrence-input"
                  formControlName="monthlyRecurrenceConfigDay"
                  [items]="recurrenceDays"
                  [readonly]="readonly"
                  [placeholder]="'button.select' | translate"
                >
                  <ng-template issSelectOption let-item>
                    {{ item | recurrenceScheduleDay:false }}
                  </ng-template>
                </iss-select>
                <input
                  issInput
                  type="number"
                  class="iss-daily-recurrence-input"
                  data-e2e="monthly recurrence number field"
                  formControlName="monthlyRecurrenceConfigCounter"
                  [placeholder]="'iss-wo-common.recurrence-schedule.recurrence-type.month' | translate"
                  [readonly]="readonly"
                >
              </wo-monthly-nth-recurrence>
            </label>
          </div>
        </div>
      </ng-container>
      <ng-template issFormFieldError let-errorsByFields="errorsByFields">
        <ng-container *ngFor="let errors  of errorsByFields | keyvalue | slice:0:1">
          <ng-container *ngIf="errors.key === 'monthlyRecurrenceDayNumber' && $any(errors.value).min">{{ 'iss-wo-common.error.minimum' | translate: {field: "Day", minimum: $any(errors.value).min?.min} }}</ng-container>
          <ng-container *ngIf="errors.key === 'monthlyRecurrenceDayNumber' && $any(errors.value).max">{{ 'iss-wo-common.error.maximum' | translate: {field: "Day", maximum: $any(errors.value).max?.max} }}</ng-container>
          <ng-container *ngIf="errors.key === 'dailyRecurrenceCounter' && $any(errors.value).min">{{ 'iss-wo-common.error.minimum' | translate: {field: "Reccurence", minimum: $any(errors.value).min?.min}  }}</ng-container>
          <ng-container *ngIf="errors.key === 'weeklyRecurrenceCounter' && $any(errors.value).min">{{ 'iss-wo-common.error.minimum' | translate: {field: "Reccurence", minimum: $any(errors.value).min?.min}  }}</ng-container>
          <ng-container *ngIf="errors.key === 'monthlyRecurrenceCounter' && $any(errors.value).min">{{ 'iss-wo-common.error.minimum' | translate: {field: "Reccurence", minimum: $any(errors.value).min?.min}  }}</ng-container>
          <ng-container *ngIf="errors.key === 'weeklyRecurrenceDayNames' && $any(errors.value).required">{{ 'iss-wo-common.error.at-least-one-day' | translate }}</ng-container>
          <ng-container *ngIf="errors.key !== 'weeklyRecurrenceDayNames' && $any(errors.value).required">{{ 'iss-core.error.required'  | translate }}</ng-container>
        </ng-container>
      </ng-template>
    </iss-form-field>
  </div>
</ng-container>
